import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PackCard } from '../components/PackCard';
const packs = [{
  title: 'Nutrición',
  description: 'Sistema completo para nutricionistas: planes, recetas, seguimiento y educación alimentaria.',
  packTitle: 'NUTRICIÓN LISTA',
  themeColor: 'navy' as const,
  imageSrc: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779676327/nutri-Photoroom_lqu1oy.png',
  href: 'https://nutripro.bibliotecaprofesional.com/',
  category: 'profesionales'
}, {
  title: 'Fonoaudiología',
  description: 'Actividades, sesiones y materiales listos para trabajar con pacientes.',
  packTitle: 'FONO PRO',
  themeColor: 'blue' as const,
  imageSrc: 'PEGAR_AQUI_LINK_DE_IMAGEN_FONOAUDIOLOGIA',
  href: 'PEGAR_AQUI_LINK_DEL_PRODUCTO_FONOAUDIOLOGIA',
  category: 'profesionales'
}, {
  title: 'Psicología',
  description: 'Recursos profesionales para sesiones, consultorio y organización clínica.',
  packTitle: 'PSICO PRO',
  themeColor: 'green' as const,
  imageSrc: 'PEGAR_AQUI_LINK_DE_IMAGEN_PSICOLOGIA',
  href: 'PEGAR_AQUI_LINK_DEL_PRODUCTO_PSICOLOGIA',
  category: 'profesionales'
}, {
  title: 'Acompañante Terapéutico',
  description: 'Material práctico para intervenciones, seguimiento y trabajo diario.',
  packTitle: 'TERAPÉUTICO PRO',
  themeColor: 'pink' as const,
  imageSrc: 'PEGAR_AQUI_LINK_DE_IMAGEN_ACOMPANANTE',
  href: 'PEGAR_AQUI_LINK_DEL_PRODUCTO_ACOMPANANTE',
  category: 'profesionales'
}, {
  title: 'Psicopedagogía',
  description: 'Planificaciones, actividades y recursos listos para aplicar.',
  packTitle: 'PSICOPEDAGÓGICO PRO',
  themeColor: 'purple' as const,
  imageSrc: 'PEGAR_AQUI_LINK_DE_IMAGEN_PSICOPEDAGOGIA',
  href: 'PEGAR_AQUI_LINK_DEL_PRODUCTO_PSICOPEDAGOGIA',
  category: 'estudiantes'
}, {
  title: 'Terapia Ocupacional',
  description: 'Herramientas clínicas y actividades listas para usar en consultorio.',
  packTitle: 'TERAPIA OCUPACIONAL',
  themeColor: 'teal' as const,
  imageSrc: 'PEGAR_AQUI_LINK_DE_IMAGEN_TERAPIA_OCUPACIONAL',
  href: 'PEGAR_AQUI_LINK_DEL_PRODUCTO_TERAPIA_OCUPACIONAL',
  category: 'estudiantes'
}];
export function ElegirPack() {
  const [selectedCategory, setSelectedCategory] = useState<'profesionales' | 'estudiantes'>('profesionales');
  const filteredPacks = packs.filter(pack => pack.category === selectedCategory);
  return <div className="min-h-screen bg-[#F6F5F2] py-16 px-4 sm:px-6 lg:px-8 font-sans selection:bg-green-200 selection:text-green-900" data-id="element-38">
      <div className="max-w-[1400px] mx-auto" data-id="element-39">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-40">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.4
        }} className="bg-[#E5F7EB] text-[#0A7D3B] text-xs font-bold px-4 py-1.5 rounded-full tracking-wider uppercase mb-6" data-id="element-41">
            Packs digitales para profesionales y estudiantes
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#111111] tracking-tight mb-6" data-id="element-42">
            ¿Qué tipo de material buscas?
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-500 max-w-2xl mx-auto mb-8" data-id="element-43">
            Elegí tu pack y accedé a recursos listos para usar, imprimir y
            ahorrar horas de trabajo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-wrap items-center justify-center gap-3" data-id="element-44">
            <button onClick={() => setSelectedCategory('profesionales')} className={`px-6 lg:px-8 py-3 rounded-full font-semibold text-base leading-none transition-all duration-150 min-w-[170px] ${selectedCategory === 'profesionales' ? 'bg-[#0A7D3B] text-white shadow-[0_5px_0_0_#065F2C]' : 'bg-white text-[#0A7D3B] border border-[#0A7D3B]'}`} data-id="element-45">
              Profesionales
            </button>

            <button onClick={() => setSelectedCategory('estudiantes')} className={`px-6 lg:px-8 py-3 rounded-full font-semibold text-base leading-none transition-all duration-150 min-w-[170px] ${selectedCategory === 'estudiantes' ? 'bg-[#0A7D3B] text-white shadow-[0_5px_0_0_#065F2C]' : 'bg-white text-[#0A7D3B] border border-[#0A7D3B]'}`} data-id="element-46">
              Estudiantes
            </button>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center" data-id="element-47">
          {filteredPacks.map((pack, index) => <PackCard key={pack.title} title={pack.title} description={pack.description} packTitle={pack.packTitle} themeColor={pack.themeColor} imageSrc={pack.imageSrc} href={pack.href} delay={0.3 + index * 0.1} data-id="element-48" />)}
        </div>
      </div>
    </div>;
}